import { useState } from "react";
import axios from "axios";
import { Eye, EyeOff, Lock } from "lucide-react";
import { API } from "../../lib/apiClient";
import logoIcon from "../../assets/logo_icon.png";

export function LoginScreen({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setSubmitting(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { username: username.trim().toLowerCase(), password });
      onLogin(res.data);
    } catch (err) { setError(err.response?.data?.detail || "Could not sign in"); } finally { setSubmitting(false); }
  };

  return <div className="login-shell" data-testid="login-screen">
    <div className="login-card">
      <div className="login-brand"><img src={logoIcon} alt="Surya's Exports" className="brand-logo-img" /><div><strong>Surya's Exports</strong><span>Inventory & Dispatch Desk</span></div></div>
      <h1>Sign in to the plant desk</h1>
      <p className="login-sub">Use the role login given to your team to view stock and dispatches.</p>
      {error && <div className="login-error" data-testid="login-error">{error}</div>}
      <form onSubmit={submit} className="modal-form">
        <label>Username
          <input data-testid="login-username-input" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="e.g. store" autoFocus required />
        </label>
        <label>Password
          <div className="password-field">
            <input data-testid="login-password-input" type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter password" required />
            <button type="button" data-testid="login-password-toggle" aria-label="Toggle password visibility" onClick={() => setShowPassword(!showPassword)}>{showPassword ? <EyeOff size={15} /> : <Eye size={15} />}</button>
          </div>
        </label>
        <button type="submit" className="button primary login-submit" data-testid="login-submit-button" disabled={submitting}><Lock size={16} /> {submitting ? "Signing in…" : "Sign in"}</button>
      </form>
      <p className="login-foot">5 role logins: Admin, Production Manager, Store, Accounts, Manager.</p>
    </div>
  </div>;
}
